import styled from "styled-components";
import theme from "~/styles/theme";

export const P = styled.p`
  color: ${(props) =>
    props.primary ? theme.palette.brand.primary.key : theme.palette.neutral.primary.key};
  font-family: ${(props) =>
    props.emphasis
      ? theme.typography.secondaryFont
      : theme.typography.fontFamily};
  text-decoration: ${(props) =>
    props.underline
      ? "underline"
      : "auto"};

    &.text-black {
      color: #1B1B19 !important;
    }
`;
export const Span = styled.span`
  color: ${(props) =>
    props.primary ? theme.palette.brand.primary.key : theme.palette.neutral.primary.key};
  font-family: ${(props) =>
    props.emphasis
      ? theme.typography.secondaryFont
      : theme.typography.fontFamily};
  &.text-4 {
    color: white;
  }

  &.userButton {
    max-width: 100%;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    display: block;
  }
`;
export const Strong = styled.strong`
  color: ${(props) =>
    props.primary ? theme.palette.brand.primary.key : theme.palette.neutral.primary.key};
  font-family: ${(props) =>
    props.emphasis
      ? theme.typography.secondaryFont
      : theme.typography.fontFamily};
  text-decoration: ${(props) =>
    props.underline
      ? "underline"
      : "auto"};
`;
export const Anchor = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) =>
    props.primary ? theme.palette.brand.primary.key : theme.palette.neutral.primary.key};
  font-family: ${(props) =>
    props.emphasis
      ? theme.typography.secondaryFont
      : theme.typography.fontFamily};

  &.blueSpan {
    color: #044688 !important;
  }
`;
